import type { Interpolation } from "@emotion/react";

export const stylesScale: Record<string, Interpolation> = {
  base: {
    transition: "all 150ms ease-out",
  },
  l: {
    scale: 1,
    ":hover": { scale: 1.015 },
    ":active": { scale: 0.985 },
  },
  m: {
    scale: 1,
    ":hover": { scale: 1.00875 },
    ":active": { scale: 0.99125 },
  },
  s: {
    scale: 1,
    ":hover": { scale: 1.0025 },
    ":active": { scale: 0.9975 },
  },
};
